export enum EMeetingRole {
  HOST = 'clinician',
  PATIENT = 'patient',
  GUEST = 'guest',
}
